
  export const dictText=(val, list)=> {
    let text = "None";
    list.forEach(obj => {
      if (obj.value == val) {
        text = obj.text;
      }
    });
    return text;
  }

